module.exports = __webpack_public_path__ + "static/media/imgplaceholder.662461d4.png";